import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  iconoirBrain,
  iconoirCodeBrackets,
  iconoirCompass,
  iconoirGraphUp,
  iconoirGroup,
  iconoirShieldCheck,
} from '@ng-icons/iconoir';

@Component({
  selector: 'app-dual-pillar',
  templateUrl: './dual-pillar.component.html',
  styleUrls: ['./dual-pillar.component.scss'],
  imports: [TranslatePipe, LangRouterLink, NgIcon],
  providers: [provideIcons({ iconoirBrain, iconoirCodeBrackets, iconoirCompass, iconoirGraphUp, iconoirGroup, iconoirShieldCheck })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DualPillarComponent {
  public readonly products = [
    {
      nameKey: 'main_page.dual_pillar.traffic_analytics',
      descKey: 'main_page.dual_pillar.traffic_desc',
      ngIcon: 'iconoirGraphUp',
    },
    {
      nameKey: 'main_page.dual_pillar.journey_analytics',
      descKey: 'main_page.dual_pillar.journey_desc',
      ngIcon: 'iconoirCompass',
    },
    {
      nameKey: 'main_page.dual_pillar.qiq',
      descKey: 'main_page.dual_pillar.qiq_desc',
      ngIcon: 'iconoirGroup',
    },
  ];

  public readonly iaasServices = [
    {
      nameKey: 'main_page.dual_pillar.ai_consulting',
      descKey: 'main_page.dual_pillar.ai_consulting_desc',
      icon: 'iconoirBrain',
    },
    {
      nameKey: 'main_page.dual_pillar.applied_dev',
      descKey: 'main_page.dual_pillar.applied_dev_desc',
      icon: 'iconoirCodeBrackets',
    },
    {
      nameKey: 'main_page.dual_pillar.ai_governance',
      descKey: 'main_page.dual_pillar.ai_governance_desc',
      icon: 'iconoirShieldCheck',
    },
  ];
}
